import { render, staticRenderFns } from "./ticket-headers.vue?vue&type=template&id=46554ea0"
import script from "./ticket-headers.vue?vue&type=script&lang=js"
export * from "./ticket-headers.vue?vue&type=script&lang=js"
import style0 from "./ticket-headers.vue?vue&type=style&index=0&id=46554ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports